import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    about: [
      { label: 'プロジェクト概要', path: '/about' },
      { label: '心不全とは', path: '/heart-failure' },
      { label: '早期発見', path: '/early-detection' },
      { label: '検査方法', path: '/examination' },
    ],
    cooperation: [
      { label: '地域連携', path: '/regional-cooperation' },
      { label: '紹介病院一覧', path: '/referral-hospitals' },
      { label: '研究活動', path: '/research' },
    ],
    information: [
      { label: 'お知らせ', path: '/news' },
      { label: 'コラム', path: '/column' },
      { label: '資料ダウンロード', path: '/resources' },
      { label: 'お問い合わせ', path: '/contact' },
    ],
  };

  return (
    <footer className="bg-primary-600 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 cursor-pointer group">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/fdb0f750-1c72-40f4-98ed-1e14743b20db.png"
                  alt="Heart Care Logo"
                  className="w-full h-full object-contain p-1"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white">心不全連携プロジェクト</span>
                <span className="text-xs text-white/80">虎の門病院循環器センター、心リハチーム</span>
              </div>
            </Link>
            <p className="text-white/80 text-sm leading-relaxed">
              心不全の早期発見と慢性管理をサポートする医療連携プロジェクト
            </p>
          </div>

          {/* About Links */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">プロジェクトについて</h3>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Cooperation Links */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">医療連携</h3>
            <ul className="space-y-2">
              {footerLinks.cooperation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Information Links */}
          <div>
            <h3 className="text-base font-bold mb-4 text-white">情報</h3>
            <ul className="space-y-2">
              {footerLinks.information.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-sm">
              © {currentYear} 国家公務員共済組合連合会 虎の門病院 循環器センター
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
